import { DeleteFilled } from '@ant-design/icons';
import { createEnumOptions } from '@/utils/core/data-transformation';
import { getEnumNamespace } from '@/utils/infrastructure';
import { CoreEnums } from '@/utils/domain/constants';
import Filters, { registerModuleFilters } from '@/utils/input/filters';

const PlatformFilter = {
  ...Filters.BaseFilters.EnumFilter,
  name: 'reportPlatform',
  label: 'reports.platform',
  enumNamespace: getEnumNamespace(CoreEnums.ReportPlatform),
  enumSource: CoreEnums.ReportPlatform,
  options: createEnumOptions(CoreEnums.ReportPlatform, 'reports.platform'),
};

const TypeFilter = {
  ...Filters.BaseFilters.EnumFilter,
  name: 'type',
  label: 'global.type',
  enumNamespace: getEnumNamespace(CoreEnums.ReportType),
  enumSource: CoreEnums.ReportType,
  options: createEnumOptions(CoreEnums.ReportType, 'reports.type'),
};

const GroupFilter = {
  ...Filters.BaseFilters.RemoteFilter,
  name: 'reportGroupId',
  label: 'global.text.group',
  apiRoute: 'reportGroup/paged',
  params: {
    select: 'id,name',
    filter: 'isActive eq true',
    orderBy: 'name asc',
  },
};

const ProcessFilter = {
  ...Filters.BaseFilters.RemoteFilter,
  name: 'processId',
  label: 'global.text.process',
  apiRoute: 'process/paged',
  params: {
    select: 'id,name',
    filter: 'isActive eq true',
    orderBy: 'name asc',
  },
};

const IsPublicFilter = {
  ...Filters.BaseFilters.BooleanFilter,
  name: 'isPublic',
  label: 'global.text.isPublic',
};

const CreatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.createdDate',
};

const UpdatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.updatedDate',
  name: 'updatedDateRange',
};

export const filtersConfig = [
  PlatformFilter,
  TypeFilter,
  GroupFilter,
  ProcessFilter,
  IsPublicFilter,
  Filters.IsActiveFilter,
  CreatedDateFilter,
  UpdatedDateFilter,
];

registerModuleFilters('reports', [
  PlatformFilter,
  TypeFilter,
  GroupFilter,
  ProcessFilter,
  IsPublicFilter,
]);

export const getReportOptionsItems = (formatMessage) => [
  {
    key: 'delete',
    label: formatMessage({ id: 'global.text.delete' }),
    icon: <DeleteFilled />,
    danger: true,
  },
];
